import { render, staticRenderFns } from "./genericFlowButton.vue?vue&type=template&id=1f4a91b2&"
import script from "./genericFlowButton.vue?vue&type=script&lang=js&"
export * from "./genericFlowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports